import { render, staticRenderFns } from "./Alaska.vue?vue&type=template&id=f66c4762&"
import script from "./Alaska.vue?vue&type=script&lang=js&"
export * from "./Alaska.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports